import React, { useState } from 'react';
import './AssignPopup.css';
import close from "../../Assets/close.svg";

const AssignPopup = ({ 
  isOpen, 
  onClose, 
  onAssign, 
  tlUsers = [], 
  userDesignation = "TL" 
}) => {
  const [selectedOption, setSelectedOption] = useState('self-assign');
  const [selectedUser, setSelectedUser] = useState("");

  const handleAssign = (action) => {
    if (userDesignation === 'Manager' && action === 'accept') {
      onAssign(selectedUser, 'assign');
    } else if (action === 'accept') {
      onAssign('self-assign', 'accept');
    } else if (action === 'reject') {
      onAssign('', 'reject');
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="assign-popup-overlay">
      <div className="assign-popup">
        <div className="assign-popup-header">
          <h3 className="assign-title">Assign Application</h3>
          <button className="close-btn" onClick={onClose}><img src={close} alt="" /></button>
        </div>
        
        <div className="assign-content">
          <h4 className="choose-title">Assignment Option</h4>
          <div className="tl-options">
            {userDesignation === 'Manager' ? (
              tlUsers.length > 0 ? (
                tlUsers.map((user) => (
                  <label key={user._id} className="tl-option">
                    <input
                      type="radio"
                      name="tl"
                      value={user._id}
                      checked={selectedUser === user._id}
                      onChange={(e) => setSelectedUser(e.target.value)}
                    />
                    <span className="radio-custom"></span>
                    {user.name}
                  </label>
                ))
              ) : (
                <p style={{ textAlign: "center", color: "#666", padding: "20px" }}>
                  No TL users available
                </p>
              )
            ) : (
              <label className="tl-option">
                <input
                  type="radio"
                  name="assignment"
                  value="self-assign"
                  checked={selectedOption === 'self-assign'}
                  onChange={(e) => setSelectedOption(e.target.value)}
                />
                <span className="radio-custom"></span>
                Self Assign
              </label>
            )}
          </div>
        </div>

        <div className="assign-actions">
          <button 
            className="reject-btn" 
            onClick={() => handleAssign('reject')}
          >
            {userDesignation === 'Manager' ? 'Cancel' : 'Reject'}
          </button>
          <button 
            className="accept-btn" 
            disabled={userDesignation === 'Manager' && !selectedUser}
            onClick={() => handleAssign('accept')}
          >
            {userDesignation === 'Manager' ? 'Assign' : 'Accept'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignPopup;